var map = {
	"./assets/icons/A2HBtn.svg": [
		6106,
		6106
	],
	"./assets/icons/Carteav_Brand_Horizontal.svg": [
		5060,
		5060
	],
	"./assets/icons/Carteav_Brand_Vertical.svg": [
		9090,
		9090
	],
	"./assets/icons/active_cars.svg": [
		8505,
		8505
	],
	"./assets/icons/add.svg": [
		1480,
		1480
	],
	"./assets/icons/answerCall.svg": [
		33,
		33
	],
	"./assets/icons/callBtn.svg": [
		2869,
		2869
	],
	"./assets/icons/cartIcon2D.svg": [
		9564,
		9564
	],
	"./assets/icons/cart_avalible.svg": [
		9326,
		9326
	],
	"./assets/icons/cart_busy.svg": [
		2923,
		2923
	],
	"./assets/icons/carteavicon-png.png": [
		3482,
		3482
	],
	"./assets/icons/carteavicon.svg": [
		888,
		888
	],
	"./assets/icons/carteaviconGrey.svg": [
		6161,
		6161
	],
	"./assets/icons/declineCall.svg": [
		1283,
		1283
	],
	"./assets/icons/deleteIcon.svg": [
		5489,
		5489
	],
	"./assets/icons/destIcon.svg": [
		804,
		804
	],
	"./assets/icons/driver-icon.svg": [
		7397,
		7397
	],
	"./assets/icons/endCall.svg": [
		5430,
		5430
	],
	"./assets/icons/enterCart.svg": [
		241,
		241
	],
	"./assets/icons/golf-cart-.svg": [
		7835,
		7835
	],
	"./assets/icons/hardReset.svg": [
		365,
		365
	],
	"./assets/icons/location_black.png": [
		464,
		464
	],
	"./assets/icons/location_white.png": [
		5898,
		5898
	],
	"./assets/icons/map.svg": [
		9543,
		9543
	],
	"./assets/icons/marker-flag.svg": [
		6676,
		6676
	],
	"./assets/icons/nearByIcon.svg": [
		8993,
		8993
	],
	"./assets/icons/nearByIcon1.svg": [
		1202,
		1202
	],
	"./assets/icons/offline.svg": [
		3820,
		3820
	],
	"./assets/icons/online.svg": [
		9674,
		9674
	],
	"./assets/icons/play.svg": [
		757,
		757
	],
	"./assets/icons/poi_wrapper.svg": [
		5121,
		5121
	],
	"./assets/icons/pois/colture.svg": [
		7906,
		5525
	],
	"./assets/icons/pois/drinks.svg": [
		8278,
		8278
	],
	"./assets/icons/pois/facilities.svg": [
		7200,
		7200
	],
	"./assets/icons/pois/food.svg": [
		3623,
		3623
	],
	"./assets/icons/pois/generic_poi.png": [
		5329,
		5329
	],
	"./assets/icons/pois/history.svg": [
		1289,
		1289
	],
	"./assets/icons/pois/living_area.svg": [
		1504,
		1504
	],
	"./assets/icons/pois/nature.svg": [
		106,
		106
	],
	"./assets/icons/pois/services.svg": [
		3275,
		3275
	],
	"./assets/icons/pois/shop.svg": [
		1551,
		1551
	],
	"./assets/icons/pois/sport.svg": [
		5699,
		5699
	],
	"./assets/icons/ratesIcons/rateEmojie_1.svg": [
		6720,
		6720
	],
	"./assets/icons/ratesIcons/rateEmojie_2.svg": [
		1859,
		1859
	],
	"./assets/icons/ratesIcons/rateEmojie_3.svg": [
		3922,
		3922
	],
	"./assets/icons/ratesIcons/rateEmojie_4.svg": [
		7853,
		7853
	],
	"./assets/icons/ratesIcons/rateEmojie_5.svg": [
		3580,
		3580
	],
	"./assets/icons/searchIcon.svg": [
		5176,
		5176
	],
	"./assets/icons/selectedNearByIcon.svg": [
		838,
		838
	],
	"./assets/icons/selectedNearByIcon1.svg": [
		56,
		7675
	],
	"./assets/icons/selectedNearByIcon2.svg": [
		3288,
		3288
	],
	"./assets/icons/softReset.svg": [
		7748,
		7748
	],
	"./assets/icons/stop.svg": [
		6139,
		6139
	],
	"./assets/icons/userLocation.svg": [
		8927,
		8927
	],
	"./assets/icons/warning.svg": [
		2865,
		2865
	],
	"./assets/incomingRingtone.mp3": [
		108,
		108
	],
	"./assets/map/map_image-min.jpeg": [
		5207,
		5207
	],
	"./assets/map/map_image.png": [
		6365,
		6365
	],
	"./assets/ring.mp3": [
		1348,
		1348
	],
	"./assets/teams.mp3": [
		9628,
		9628
	],
	"./assets/toneRing.mp3": [
		7660,
		7660
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9318;
module.exports = webpackAsyncContext;